/* app/js/src/components/autopilot/graphicsRuleWizard/autopilot-rule-wizard.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
section {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.root-container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.root-container .mam {
  max-width: 380px;
  width: 380px;
}
.root-container .wizard {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
.root-container .wizard header div {
  font-size: 12px;
  font-weight: bold;
  color: #232f3a;
  letter-spacing: -0.1px;
  height: 54px;
  padding: 27px;
}
.root-container .wizard main {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.root-container .wizard main .summary {
  max-width: 40%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
filter {
  position: absolute;
  top: 70px;
  left: 455px;
  width: 300px;
  z-index: 1;
  height: calc(100% - 70px);
  background-color: #eef2f6;
  max-height: 100vh;
  overflow: hidden;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -webkit-box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0);
  -moz-box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0);
  box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0);
}
filter.visible {
  -webkit-box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0.2);
}
/*# sourceMappingURL=autopilot-rule-wizard.component.css.map */
